import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import imageResizer from 'js/image-resizer-utils'

import './FluidImage.scss'

/**
 * Image
 * Transforms:
 * 'fill' - image is cropped according to container proportions to fill it completely.
 * 'fit' - image is resized with saving original proportions to fit container by width or height.
 */

const transforms = {
    fill: 'fill',
    fit: 'fit',
};

const FluidImage = ({
    className,
    url,
    alt,
    focusPoint,
    fallback,
    transform = transforms.fill,
    size,
    width,
    height
}) => {
    const targetWidth = width !== undefined ? width : size;
    const targetHeight = height !== undefined ? height : size;
    const imageUrl = url ? 
        imageResizer.buildResizeUrl(
            url, 
            targetWidth, 
            targetHeight, 
            transform === transforms.fill
                ? imageResizer.Transforms.downFill
                : imageResizer.Transforms.downFit, 
            focusPoint?.x ?? 0, 
            focusPoint?.y ?? 0) : 
        fallback

    return (
        <div
            className={cn('fluid-image', className)}
            style={{
                backgroundImage: `url(${imageUrl})`,
                backgroundPosition: focusPoint ? `${focusPoint.x}% ${focusPoint.y}%` : null
            }}
        >
            {url && <img src={imageUrl} alt={alt ? alt : ''} />}
        </div>
    )
}

FluidImage.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string,
    alt: PropTypes.string,
    focusPoint: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }),
    transform: PropTypes.oneOf(Object.values(transforms)),
    fallback: PropTypes.string,
    size: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
}

export default FluidImage
